// from browser-util-inspect
const colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39],
};
/**
 * Colorize a string with a specified color.
 * @param str String to colorize
 * @param color Color to colorize the string with
 * @returns Colorized string
 */
export function colorize(str, color) {
    const colorData = colors[color];
    return '\u001b[' + colorData[0] + 'm' + str + '\u001b[' + colorData[1] + 'm';
}
/**
 * Gets a stack trace from metadata or accompanying error.
 */
function getStackTrace(data) {
    const stack = data?.err?.stack || data.stack || data['error.stack'];
    delete data.stack;
    return stack ?? '';
}
export function consoleTransport(config = {}) {
    // Default ignore patterns
    config.ignoreMetadataPatterns ??= ['application', 'service', 'environment', 'version'];
    // Get the colorizer function, or a no-op if not enabled.
    const colorizer = config.colorize !== false ? config.colorize ?? colorize : (str) => str;
    // Get the log level color function, or use the default colors.
    const getLogLevelColor = config.getLogLevelColor ??
        ((level) => {
            return {
                error: 'red',
                warn: 'yellow',
                info: 'cyan',
                debug: 'green',
            }[level];
        });
    const transport = {
        ...config,
        log: ({ level, message, timestamp, splat, ...metadata }) => {
            let splatData = splat ?? [];
            const stackTrace = getStackTrace(metadata);
            const strippedInfo = { ...metadata };
            delete strippedInfo['level'];
            delete strippedInfo['message'];
            delete strippedInfo['splat'];
            delete strippedInfo['timestamp'];
            delete strippedInfo['stack'];
            if (Object.keys(strippedInfo).length > 0) {
                splatData = [strippedInfo, ...splatData];
            }
            if (message) {
                splatData = [message, ...splatData];
            }
            if (stackTrace) {
                splatData = [...splatData, stackTrace];
            }
            console.log(`${colorizer(timestamp, 'magenta')} ${colorizer(level, getLogLevelColor(level))}: `, ...splatData);
        },
    };
    return transport;
}
//# sourceMappingURL=consoleTransport.js.map